module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-de-2.34845255.png";